import {IGlobalStore} from 'modules/types';

export const getTriviaLeaderboardSnippet = ({leaderboard_snippet}: IGlobalStore) => leaderboard_snippet.trivia.snippet;
export const getPPLeaderboardSnippet = ({leaderboard_snippet}: IGlobalStore) => leaderboard_snippet.pp.snippet;
export const getPPLeaderboardMonth = ({leaderboard_snippet}: IGlobalStore) => leaderboard_snippet.pp.month;
